import { render, staticRenderFns } from "./StatPage.vue?vue&type=template&id=4610d367&"
import script from "./StatPage.vue?vue&type=script&lang=js&"
export * from "./StatPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports